module.exports = __webpack_public_path__ + "img/signin.8c67f3a9.svg";